import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import ProductCard from "@/components/ProductCard";

export default function Catalogue() {
  const { t } = useLang();
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = (query) => {
    setLoading(true);
    api.get("/products", { params: query ? { q: query } : {} })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const query = params.get("q") || "";
    setQ(query);
    fetchProducts(query);
  }, [params]);

  const onSubmit = (e) => {
    e.preventDefault();
    setParams(q ? { q } : {});
  };

  return (
    <div className="max-w-6xl mx-auto px-5 md:px-8 py-8 md:py-12 fade-in">
      <form onSubmit={onSubmit} className="relative mb-8 max-w-xl">
        <Search className="absolute top-1/2 -translate-y-1/2 start-3 w-4 h-4 text-text-muted" strokeWidth={1.5} />
        <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input"
          placeholder={t("searchPlaceholder")}
          className="w-full bg-surface border border-border ps-10 pe-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary" />
      </form>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-testid="catalogue-loading">
          {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
            <div key={i} className="aspect-[4/5] bg-surface animate-pulse" />
          ))}
        </div>
      ) : products.length === 0 ? (
        <p className="text-text-muted py-16 text-center" data-testid="no-results">{t("noResults")}</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-testid="catalogue-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} priority={i < 4} contain />)}
        </div>
      )}
    </div>
  );
}
